export default function ShortKeys() {
  return (
    <div className="side2">
      <ul id="shortkeys"></ul>
    </div>
  );
}